<template>
  <div v-if="model.params.done">
    <span v-if="!model.hasTransport" v-translate>
      There are no more seats available for your search.
      Please change your search criteria.
    </span>
    <span v-else-if="model.results">
      <!-- {{model.params}} -->
      <b>
        <translate>Search results:</translate> {{ model.params.resortName}} - {{ model.params.duration }} <translate>nights</translate>
      </b>,&nbsp;
      <span v-for="(room, index) in model.params.rooms" :key="index">
        <span class="tag-details"><translate>Room:</translate> {{index + 1 }} - </span>
        <span>{{room.adults}} </span><span class="name-details" v-translate> adults</span>
        <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} <translate>children</translate>  - <translate>age</translate>:
          {{ room.ages.join(', ')}}
        </span>,
      </span>
      <strong>&nbsp;{{ model.results.length }}</strong> <translate>results</translate>
      <!-- {{ model.results}} -->
    </span>
    <span v-else v-translate>
      There are no more seats available for your search.
      Please change your search criteria.
    </span>
  </div>
</template>

<script>
import model from '../services/model'

export default {
  name: 'SearchResultsSummary',
  params: ['params'],
  data () {
    return {
      model
    }
  }
}
</script>

<style>
.results {
  background-color: rgb(112, 99, 90);
  padding: 10px;
  color: #fff;
  border-radius: 4px;
}
.breadcrumb li {
  font-size: 13px;
  text-align: center;
}
.SPOEBD {
  font-size: 14px;
  font-weight: 600;
  color: #d13239;
}

.RQNA {
  font-size: 14px;
  font-weight: 600;
  color: #000;
}
.FCAVL {
  font-size: 14px;
  font-weight: 600;
  color: green;
}
</style>
